import React from "react"
import { Link } from "@components/common/link/Link"

import { Props } from "./ImageCta.interface"
import * as s from "./ImageCta.module.scss"

export const ImageCta = ({ data }: Props) => {
  const panels = data.callToAction
  const centered = data.type === "centered"
  const typeClass = centered && s.imageCta__centered

  if (!panels) {
    return <></>
  }

  return (
    <div className={`${s.imageCta} ${typeClass}`}>
      {panels.map((panel, i) => {
        return (
          <Link
            to={
              panel.link &&
              panel.link.url.replace(/^.*\/\/[^\/]+/, "").replace(/\/home/g, "")
            }
            className={`${s.imageCta__panel} ${
              centered && s.imageCta__panelCentered
            }`}
            style={{
              backgroundImage: `url(${panel.backgroundImage.sourceUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            key={i}
          >
            <div
              className={`${s.imageCta__panel___text} ${
                centered && s.imageCta__panel___textCentered
              }`}
            >
              {panel.title && <h5>{panel.title}</h5>}
            </div>
          </Link>
        )
      })}
    </div>
  )
}

export default ImageCta
